import * as React from 'react';
import { StyledCol } from './Grid.style';

type Props = {
    xs?: boolean | number
    sm?: boolean | number
    md?: boolean | number
    lg?: boolean | number
    xl?: boolean | number
    xxl?: boolean | number
    mobile?: boolean
    tablet?: boolean
    desktop?: boolean
    gutter?: number | string
}

const Col: React.FC<Props> = (props: any): React.ReactElement => <StyledCol {...props} />;

export default Col;
